import { render } from "./CollectionPanel.vue?vue&type=template&id=ea7a7c44&scoped=true"
import script from "./CollectionPanel.vue?vue&type=script&lang=js"
export * from "./CollectionPanel.vue?vue&type=script&lang=js"

import "./CollectionPanel.vue?vue&type=style&index=0&id=ea7a7c44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea7a7c44"]])

export default __exports__